import api from "../../services/api-configuration";

export const getPersonKontrolByGrupajNo = async () => {
    // const response = await axios.post('https://jsonplaceholder.typicode.com/posts');
    try {
        const response = await api.post("/groupage/getVehicleDetails", {
            groupage_no: document.getElementById("grupajNo").childNodes[0].childNodes[0].childNodes[0].value
        })
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}
export const markChassisScanned = async (body) => {

    // /markChassisScanned
    try {
        const response = await api.post("/groupage/markChassisScanned", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}